import {combineReducers} from "redux";
import {Action, ActionsTypes, AlertReducer, UIReducer, AuthReducer} from "@leap4/frontend";
import {DateRangeReducer } from "./dateRange.reducer"
const {RESET_ALL_STATES} = ActionsTypes


const reducers = combineReducers({
    auth: AuthReducer,
    ui: UIReducer,
    alert: AlertReducer,
    dates: DateRangeReducer,
});

const rootReducer = (state: any, action: Action) => {
    // when a logout action is dispatched it will reset redux state (Because we  want to clear all previous data of the stata (security and avoid futur bugs))
    if (action.type === RESET_ALL_STATES) {
        state = undefined;
    }

    return reducers(state, action);
};

export default rootReducer;
